import { Component, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { AsyncPipe, NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { AuthenticationService } from '../../services/authentication.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { DialogService } from '../../services/dialog.service';
import {
  getContactUsUrl,
  getLinkForGuided
} from '../../utils/app.util';
import { User } from '../../models/model';

@Component({
  selector: 'app-header',
  imports: [
    TranslateModule,
    RouterLink,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    AsyncPipe,
    NgIf,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  authService = inject(AuthenticationService);


  router = inject(Router);
  //authService = inject(AuthenticationService);
  //loggedInUser = computed(() => this.authService.loggedInUser);
  dialogService = inject(DialogService);

  signIn() {
    this.authService.navigateToSign();
  }

  signOut() {
    this.authService.logout();
  }

  /**
   *  This method checks the user's language setting and returns the appropriate link.
   * @returns the link for all guided topics based on the user's locale
   */
  getLinkForAllGuided(): string {
    const defaultUrl = 'https://us-kb.sage.com/portal/ss/';
    const caUrl = 'https://ca-kb.sage.com/portal/ss/';
    const userDetails = this.getUserDetails();

    if (this.authService.isLoggedIn) {
      const country = userDetails?.Country;
      return country === 'CA' ? caUrl : defaultUrl;
    } else {
      return getLinkForGuided();
    }
  }

  /**
   * This method checks the user's language setting and returns the appropriate contact us link.
   * @returns the contact us link based on the user's locale
   */
  getSupportContactUsLink(): string {
    let url = '';
    const userDetails = this.getUserDetails();

    if (userDetails) {
      const country = userDetails.Country;

      // Fallback to US English if no country is provided
      if (!country) {
        url = 'https://www.sage.com/en-us/support/';
      } else if (country === 'US' && this.authService.isEnglish()) {
        url = 'https://www.sage.com/en-us/support/';
      } else if (country === 'CA') {
        // Canadian French if locale is falsy, otherwise Canadian English
        url = !this.authService.isEnglish()
          ? 'https://www.sage.com/fr-ca/support/'
          : 'https://www.sage.com/en-ca/support/';
      } else {
        url = 'https://www.sage.com/en-us/support/';
      }
      return url;
    } else {
      return getContactUsUrl();
    }
  }

  /**
   * get the loggedIn user details from localStorage
   * @returns user
   */
  public getUserDetails(): User | null {
    if (this.authService.isLoggedIn) {
      return this.authService.loggedInUser;
    } else {
      return null;
    }
  }

  /**
   * Determines which portal text to display based on current route
   * @returns the translation key for the portal text
   */
  getPortalText(): string {
    const currentUrl = this.router.url;
    return currentUrl.includes('partner-reset-password') || currentUrl.includes('partner-update-password') ? 'navbar.partnerPortal' : 'navbar.customerPortal';
  }
}
